module.exports = __webpack_public_path__ + "static/media/Slide5.c6bacbfb.png";